import { NodeViewContent } from '@tiptap/react';
import { FC } from 'react';
import { PeoplePageSourceDerivedQuestionSectionComponentProps } from './types';

export const PeoplePageSourceDerivedQuestionGeneratedSection: FC<
  PeoplePageSourceDerivedQuestionSectionComponentProps
> = () => {
  return <NodeViewContent />;
};
